import { useState } from "react";
import { toast } from "react-toastify";
import { PropagateLoader } from 'react-spinners';
import Modal from "../../../molecules/Modal";
import InmuebleArchivoCard from "../../../molecules/inmueble/InmuebleArchivoCard";
import ArchivoEdit from "./ArchivoEdit";
import { VIEW_FILE } from "../../../../api/apiFiles";
import useModal from "../../../../hooks/useModal";
import { allowFiles } from "../../../../data/allowFiles";

const InmuebleDocsList = ({ data, refetch }) => {
    const [fileUrl, setFileUrl] = useState(null);
    const [selected, setSelected] = useState(null);
    const [loading, setLoading] = useState(false);
    const { open, isOpen, close } = useModal();
    const { open: openView, isOpen: isOpenView, close: closeView } = useModal();

    const handleOpenEdit = (doc) => {
        open();
        setSelected(doc);
    };

    const handleOpenView = async (doc) => {
        openView();
        setSelected(doc);
        setLoading(true);
        try {
            const response = await VIEW_FILE({ s3Key: doc?.doc?.s3Key});
            if (response) {
                setFileUrl(response);
            } else {
                console.error("No se pudo obtener la URL del archivo");
            }
        } catch (error) {
            console.error("Error al cargar el archivo:", error);
            toast.error("Error al cargar el archivo");
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        close();
        closeView();
        setSelected(null);
        setFileUrl(null);
    };

    const documentos = allowFiles && data && typeof data === "object"
    ? allowFiles
        .filter((type) => Object.prototype.hasOwnProperty.call(data, type?.tableName))
        .sort((a, b) => a?.id - b?.id)
        .map((type) => ({
            name: type?.name,
            tableName: type?.tableName,
            doc: data[type?.tableName]
        }))
    : [];

    return (
        <div className="w-full grid grid-cols-1 md:grid-cols-4 gap-4 pt-4">
            {documentos?.map((doc) => (
                <InmuebleArchivoCard
                    key={doc.tableName} doc={doc} onClickEdit={()=> handleOpenEdit(doc)} onClickView={()=> handleOpenView(doc)}
                />
            ))}
            {isOpen && selected &&
                <Modal title={`Editar ${selected.name}`} onClose={handleClose}>
                    <ArchivoEdit idTable={data.id} doc={selected} refetch={refetch} onClose={handleClose}/>
                </Modal>
            }
            {isOpenView && selected &&
                <Modal title={selected.name} onClose={handleClose} heigth="h-screen" width="w-screen">
                    {loading ? (
                        <div className="w-full h-full flex place-content-center place-items-center">
                            <PropagateLoader color="red" />
                        </div>
                    ) : (
                        <iframe title={selected.name} src={fileUrl} className="w-full h-[85vh]" />
                    )}
                </Modal>
            }
        </div>
    );
};

export default InmuebleDocsList;